module.exports = __webpack_public_path__ + "static/assets/b0798532c079669c1a91ec3d801010ab.svg";